import { useCallback, useEffect, useState } from "react";
const BASEURL = process.env.REACT_APP_BASE_URL;
const useTspData = ({city, toDate, fromDate,setTotalCount, }:{city:string,  toDate:string,fromDate:string, setTotalCount:any}) => {

  const [clustersData, setClustersData] = useState<any[]>([]);
  const [tspCount, setTspCount] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  
  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);
       
        const response = await fetch(
          `${BASEURL}/v1/insights/binCleanUpReport?city=${city}&to=${toDate}&from=${fromDate}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        // console.log("result", result);
        console.log("cleanUpDetails", result?.data?.cleanUpDetails);
       
      //  const tspInfo =  result?.data?.cleanUpDetails.map((item:any)=>{
      //     return {
      //       wardNumber:item.wardNumber,
      //       totalNumberOfTSP:item.totalNumberOfTSP,
      //       noOfTSPCleaned:item.noOfTSPCleaned,
      //       percentageOfBinCleanup:item?.percentageOfBinCleanup,
      //       percentageOfSegregation:item?.percentageOfSegregation,
      //       percentageOfNonSegregation: item?.percentageOfNonSegregation,
      //     }
      //   })
      setTspCount(result?.data?.totalCount)
      const tspInfo = result?.data?.cleanUpDetails
      ?.map((item: any) => {
        return {
          wardNumber: Number(item.wardNumber), // ensure it's a number
          totalNumberOfTSP: item.totalNumberOfTSP,
          noOfTSPCleaned: item.noOfTSPCleaned,
          percentageOfBinCleanup: item?.percentageOfBinCleanup,
          percentageOfSegregation: item?.percentageOfSegregation,
          percentageOfNonSegregation: item?.percentageOfNonSegregation,
        };
      })
      ?.sort((a: any, b: any) => a.wardNumber - b.wardNumber); // sort ascending

        console.log("tspInfo", tspInfo)
        setClustersData(tspInfo);
        setTotalCount(result?.data?.totalCluster)
        
        if (!didCancel) {
      
          didCancel =true
          }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city, toDate, fromDate]);

  return {  clustersData, tspCount, loading, error };
};

export default useTspData ;
